// extracted by mini-css-extract-plugin
module.exports = {"loader":"-cell-loader-loader-2ClNPp-"};